import { apiClient } from '@api/apiClient';

import { Feature } from './types';

export const GetFeatureFlags = async (): Promise<Feature[]> => {
  const result = await apiClient.get('FeatureFlag/GetFeatureFlags');

  if ('value' in result) {
    return result.value as Feature[];
  }
  return [] as Feature[];
};
